import PropTypes from "prop-types";
import React from "react";

import { ThinBanner, ThemeSelector } from "@theconversation/ui";

/**
 * The `MobileBanner` component represents the top banner that appears
 * on mobiles only.
 */
function MobileBanner({ donateText, message, onClick, color, theme }) {
  // Some promos are using donateText, which is a bit too linked
  // to only donations. Until we can end other promo campaigns,
  // we should support `donateText` until we can only support `message`
  const displayMessage = donateText || message;

  return (
    <ThemeSelector theme={theme}>
      <ThinBanner color={color} onClick={onClick}>
        {displayMessage}
      </ThinBanner>
    </ThemeSelector>
  );
}

MobileBanner.propTypes = {
  color: PropTypes.string,
  donateText: PropTypes.string,
  message: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

MobileBanner.defaultProps = {
  color: "primary",
  theme: "core",
  donateText: "",
  message: "",
};

export default MobileBanner;
